import React from 'react';
import PropTypes from 'prop-types';

class TextInput extends React.Component {
  handleInputChange = e => {
    const {field, inputFields, onTextChange} = this.props;

    if (
      !e.target.value &&
      inputFields.type != null &&
      inputFields.type === 'number'
    )
      return;

    if (onTextChange) {
      onTextChange(field, e.target.value);
    }
  };

  render() {
    const {value, field, width, inputFields, placeholder} = this.props;

    return (
      <input
        className="form-control"
        id={field}
        name={field}
        onChange={this.handleInputChange}
        placeholder={placeholder}
        style={{width}}
        value={value || value === 0 ? `${value}` : ''}
        {...inputFields}
      />
    );
  }
}

TextInput.defaultProps = {
  inputFields: {},
  placeholder: '',
  value: '',
  width: null,
};

TextInput.propTypes = {
  width: PropTypes.number,
  value: PropTypes.node,
  placeholder: PropTypes.string,
  inputFields: PropTypes.object,
  field: PropTypes.string.isRequired,

  // functions
  onTextChange: PropTypes.func.isRequired,
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/Common/Form/TextInput.js